import { render, staticRenderFns } from "./AddCollectionModal.vue?vue&type=template&id=ac53fcc8"
import script from "./AddCollectionModal.vue?vue&type=script&lang=js"
export * from "./AddCollectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports